"use client"

import { useHomeLogicClient } from "@/features/v2/home/components/privateHome/hooks/useHomeLogicClient"

export function HomeSessionEffects() {
  useHomeLogicClient()

  return null
}
